import { render, staticRenderFns } from "./CardSingleChip.vue?vue&type=template&id=cdbcdcfa"
import script from "./CardSingleChip.vue?vue&type=script&lang=ts"
export * from "./CardSingleChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdbcdcfa')) {
      api.createRecord('cdbcdcfa', component.options)
    } else {
      api.reload('cdbcdcfa', component.options)
    }
    module.hot.accept("./CardSingleChip.vue?vue&type=template&id=cdbcdcfa", function () {
      api.rerender('cdbcdcfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardSingleChip.vue"
export default component.exports